import { render, staticRenderFns } from "./NewsActions.vue?vue&type=template&id=48aa737e&"
import script from "./NewsActions.vue?vue&type=script&lang=js&"
export * from "./NewsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports